<template>
  <Status
    v-if="showStatus"
    :data="StatusData"
    style="max-width: 452px;margin-inline: auto"
  />
  <v-row v-else class="px-custom" align="start" justify="center">
    <!-- Header Section -->
    <v-col style="max-width: 700px" cols="12" md="8" lg="8">
      <v-col cols="12" class="mb-4">
        <v-row align="center" justify="space-between">
          <v-col
            cols="12"
            :md="isFlexible ? '4' : '6'"
            class="d-flex flex-column flex-sm-row align-center justify-space-between"
            style="gap: 8px"
          >
            <div class="d-flex   align-center">
              <v-icon
                @click="$router.back()"
                clr="var(--v-onPrimary-base)"
                class="mb-3 me-1 rotateIcon d-none d-sm-block"
                style="cursor: pointer"
                >$arrowBack</v-icon
              >
              <div class="d-flex align-center" style="gap: 10px">
                <v-img
                  :src="planData.coinDto.logoUrl"
                  width="40"
                  height="40"
                  max-width="40"
                  max-height="40"
                  class="mb-3"
                />
                <div>
                  <div class="d-flex align-center" style="gap: 6px">
                    <span class="font-Regular-24">{{
                      planData.coinDto.displayName
                    }}</span>
                    <span class="font-Regular-14 gray2--text"
                      >({{ planData.coinDto.coinUnit }})</span
                    >
                  </div>
                  <p
                    class="font-Regular-16 gray2--text text-truncate"
                    style="width: 100px;"
                  >
                    {{ planData.description }}
                  </p>
                </div>
              </div>
            </div>
            <v-btn
              class="d-block d-md-none"
              color="primary"
              @click="timeLineOpen = true"
              >{{
                $t("staking.stakingDetailPage.subscriptionPlanTimeline")
              }}</v-btn
            >
          </v-col>
          <v-col cols="12" :md="isFlexible ? '8' : '6'">
            <v-row align="center">
              <v-col
                v-if="isFlexible"
                class="d-flex flex-column align-center gray2--text"
              >
                <span class="ltr">{{ planData.planDetail.maxApy }} %</span>
                <span>{{ $t("staking.stakingDetailPage.maxAPR") }}</span>
              </v-col>
              <v-divider v-if="isFlexible"></v-divider>
              <v-col class="d-flex flex-column align-center">
                <span class="success--text font-Bold-14">
                  {{ planData.planDetail.activeAPY }}%</span
                >
                <span class="gray2--text">{{
                  $t("staking.stakingDetailPage.activeAPR")
                }}</span>
              </v-col>
              <v-divider v-if="isFlexible"></v-divider>
              <v-col
                v-if="isFlexible"
                class="d-flex flex-column align-center gray2--text"
              >
                <span class="ltr">{{ planData.planDetail.minApy }} %</span>
                <span>{{ $t("staking.stakingDetailPage.minAPR") }}</span>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-divider></v-divider>

        <div
          class="mt-8 d-flex flex-column flex-sm-row align-center justify-space-between"
          style="gap: 16px"
        >
          <div style="gap: 4px" class="d-flex align-center flex-column">
            <span class="font-Regular-16 gray2--text">{{
              $t("common.Time")
            }}</span>
            <span class="font-Medium-20 onPrimary--text"
              >{{ planData.planDetail.duration }} {{ $t("common.day") }}</span
            >
          </div>
          <div style="gap: 4px" class="d-flex align-center flex-column">
            <span class="font-Regular-16 gray2--text">
              {{ $t("staking.stakingDetailPage.Registration_Deadline") }}
            </span>
            <span class="font-Medium-20 onPrimary--text">{{
              planData.planDetail.endDate | formatDate
            }}</span>
          </div>
          <!--          <div-->
          <!--            style="gap: 4px"-->
          <!--            class="d-flex flex-column"-->
          <!--          >-->
          <!--            <span class="font-Regular-16 gray2&#45;&#45;text">APR</span>-->
          <!--            <div>-->
          <!--              <span-->
          <!--                v-if="isFlexible"-->
          <!--                class="ltr font-Medium-20 onPrimary&#45;&#45;text"-->
          <!--                >{{-->
          <!--                  `(% ${planData.planDetail.minApy}  ≈ % ${planData.planDetail.maxApy})`-->
          <!--                }}</span-->
          <!--              >-->
          <!--              <span class="ltr font-Medium-20 onPrimary&#45;&#45;text">-->
          <!--                {{ planData.planDetail.activeAPY }}%</span-->
          <!--              >-->
          <!--            </div>-->
          <!--          </div>-->

          <div
            class="d-flex align-center flex-column"
            v-if="!!planData.planDetail.renewalEndDate"
          >
            <span class="font-Regular-16 gray2--text">
              {{ $t("staking.stakingDetailPage.Renewal_End_Date") }}
            </span>
            <span class="font-Medium-20 onPrimary--text">{{
              planData.planDetail.renewalEndDate | formatDate
            }}</span>
          </div>
        </div>
      </v-col>
      <!--    Reward section-->
      <v-col cols="12" class="pa-0">
        <div>
          <div class="my-4 gray1--text text-center text-md-start">
            <span class="font-Medium-16">{{ $t("common.Reward") }}</span>
            <span class="font-Regular-14 ms-1">({{ currentCoin }})</span>
          </div>
          <div
            class="d-flex justify-center justify-md-space-between flex-wrap align-center mb-4"
            style="gap: 16px"
          >
            <v-card
              elevation="0"
              v-for="(item, i) in rewardItems"
              :key="i"
              width="138px"
              class="gray10"
              rounded="8"
            >
              <v-card-text
                class="d-flex align-center justify-center flex-column"
              >
                <span class="font-Regular-16 gray2--text">
                  {{ item.label }}
                </span>
                <span
                  class="font-Medium-16 text-truncate ltr text-center gray1--text my-1"
                  style="width: 100px;"
                  >{{ $thousandMask(item.value, exponent) }}</span
                >
                <span class="font-Regular-14 gray2--text">{{
                  currentCoin
                }}</span>
              </v-card-text>
            </v-card>
          </div>
        </div>
      </v-col>
      <!--      plan detail-->
      <v-col class="gray10 rounded-lg pe-7 ps-2 py-3">
        <div class="d-flex align-center pb-3" style="gap: 8px">
          <v-icon clr="var(--v-primary-base)">$planDetail</v-icon>
          <span>{{ $t("staking.stakingDetailPage.planDetails") }}</span>
        </div>
        <v-divider></v-divider>
        <div v-for="(item, index) in planDetailHeader" :key="index">
          <div
            v-if="item.show"
            class="d-flex align-center justify-space-between"
            :class="index === 0 ? 'mt-4' : 'mt-6'"
          >
            <span class="text-truncate" style="width: 250px;">{{
              item.label
            }}</span>
            <span
              :class="[$vuetify.rtl ? 'text-left' : 'text-right', item.dir]"
              style="width: 250px;"
              class="text-truncate"
              >{{ item.value }}</span
            >
          </div>
        </div>
      </v-col>
      <!--    balance-->
      <template v-if="isAuth">
        <v-col cols="12">
          <div class="py-0 mt-6">
            <div class="mb-2 d-flex align-center justify-space-between">
              <div>
                <span class="font-Regular-14 gray2--text"
                  >{{ $t("staking.stakingDetailPage.assets") }}
                </span>
                <span class="font-Regular-14 onPrimary--text"
                  >{{ $thousandMask(availableAmount) }} {{ selectedCurrency }}
                  {{ currentCoin }}</span
                >
              </div>
              <a
                class="d-flex align-center"
                style="gap: 4px;"
                :href="`${baseUrl}/operations/transfer?from=${currentCoin}`"
              >
                <span class="primary--text font-Medium-12">{{
                  $t("exchange.balanceIncrease")
                }}</span
                ><v-icon clr="var(--v-primary-base)" size="18"
                  >$plusAddWallet</v-icon
                >
              </a>
            </div>

            <number-input
              @earnAmount="orderAmount = $event"
              @changeAmountCurrency="
                amount = $event;
                showValidation = false;
              "
              :iso="planData.coinDto.coinUnit"
              :label="$t('exchange.amount')"
              :maximumText="$t('orderPage.numberInput.allAssetsButton')"
              :maximum="max"
              :amountCurrency="amount"
              :availableAmount="availableAmount"
              :exponent="exponent"
            ></number-input>
            <div class="d-flex align-center justify-space-between mt-1">
              <span class="font-Regular-14 gray2--text">{{
                $t("staking.stakingDetailPage.minParticipation")
              }}</span>
              <div class="font-Medium-14">
                <span class="ms-1">{{
                  $thousandMask(
                    planData.planDetail.minStakePerUser,
                    planData.coinDto.stakeScale
                  )
                }}</span>
                <span>{{ planData.coinDto.coinUnit }}</span>
              </div>
            </div>

            <div class="crypto-input-amount text-right">
              <span
                class="font-Regular-11 error--text ms-3"
                v-if="cryptoExchange && showValidation"
                >{{ cryptoExchange }}</span
              >
            </div>
          </div>
        </v-col>
        <!--      <v-col cols="12">-->
        <!--        <span class="gray2&#45;&#45;text font-Medium-16">{{-->
        <!--          $t("staking.stakingDetailPage.your_plans_step")-->
        <!--        }}</span>-->
        <!--        <TimeLine class="mt-2" :item-data="planData.planDetail" />-->
        <!--      </v-col>-->

        <v-col>
          <v-row no-gutters align="start">
            <v-col cols="12" md="7">
              <v-checkbox
                v-model="agree"
                class="custom-checkbox"
                hide-details
                dense
              >
                <template v-slot:label>
                  <v-expansion-panels flat>
                    <v-expansion-panel>
                      <v-expansion-panel-header
                        class="px-0"
                        hide-actions
                        :color="
                          $vuetify.theme.themes[
                            $vuetify.theme.dark === true ? 'dark' : 'light'
                          ].background
                        "
                      >
                        <div
                          class="font-Regular-14 gray2--text"
                          style="line-height: 1.8"
                          v-html="
                            $t(
                              'staking.stakingDetailPage.Agree_Staking_Contract_HTML'
                            )
                          "
                        ></div>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content
                        style="height: 400px;overflow: auto;display: block;padding: 16px"
                        :color="
                          $vuetify.theme.themes[
                            $vuetify.theme.dark === true ? 'dark' : 'light'
                          ].background
                        "
                        v-html="disclaimer"
                      >
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </template>
              </v-checkbox>
            </v-col>
            <v-col cols="12" md="5" class="mt-6">
              <v-btn
                color="btn-primary-color"
                :loading="isLoading"
                large
                block
                :disabled="!agree || transferFlag"
                @click="stakePlanSubmit"
              >
                {{ $t("staking.stakingPlans.plans.details.joinedStaking") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </template>
      <template v-else>
        <v-btn
          color="primary font-Medium-14"
          @click="$router.push('/auth/login')"
          block
          class="mt-4"
          >{{ $t("authPage.registerPage.signInBeforeLink") }}</v-btn
        >
      </template>
    </v-col>
    <v-col cols="12" md="4" lg="4" class="d-none d-lg-block">
      <TimeLine
        :item-data="planData.planDetail"
        style="margin-inline-start: 146px;margin-top: 100px"
      />
    </v-col>
    <v-dialog v-model="timeLineOpen" max-width="300">
      <v-card class="pa-4">
        <h3>
          {{ $t("staking.stakingDetailPage.subscriptionPlanTimeline") }} :
        </h3>
        <TimeLine :item-data="planData.planDetail" /> </v-card
    ></v-dialog>
  </v-row>
</template>

<script>
import TimeLine from "@/components/Staking/planDetailPage/TimeLine.vue";
import Status from "@/components/Staking/planDetailPage/Status.vue";

import NumberInput from "@/components/NumberInput/index.vue";
import $thousandMask from "@/mixins/thousandMask";
import $removeThousand from "@/mixins/thousandMask";
import withdrawService from "@/services/modules/market/withdraw";
import StakingService from "@/services/modules/market/staking";
import { authMixin } from "@/mixins/authMixin";

export default {
  name: "PlanDetailPage",
  components: { TimeLine, NumberInput, Status },
  mixins: [$thousandMask, $removeThousand, authMixin],
  data() {
    return {
      baseUrl: process.env.VUE_APP_BASE_URL,
      currentCoin: "",
      planData: {},
      isFlexible: false,
      agree: false,
      planId: "",
      activeAPY: "",
      isLoading: false,
      disclaimer: "",
      //balance
      orderAmount: "0",
      selectedCurrency: "",
      max: true,
      amount: null,
      availableAmount: "0",
      exponent: 0,
      showValidation: false,
      minWithdraw: null,
      maxWithdraw: null,
      transferFlag: true,
      //   flag
      showStatus: false,
      //   status
      StatusData: null,
      //   dialog
      timeLineOpen: false
    };
  },
  mounted() {
    this.planId = this.$route.params.id;
    this.fetchPlanDetails();
    this.getDisclaimer();
  },
  methods: {
    async fetchPlanDetails() {
      try {
        const { data } = await StakingService.getDetailsPlanData(this.planId);
        const response = data.data;

        this.planData = response;
        const { planDetail } = response;
        this.isFlexible = !!planDetail.maxApy && !!planDetail.minApy;
        this.activeAPY = planDetail.activeAPY;
        this.currentCoin = planDetail.unit;
        this.maxWithdraw = planDetail.maxStakePerUser;
        this.minWithdraw = planDetail.minStakePerUser;

        const token = planDetail.unit.toUpperCase();
        this.isAuth && (await this.fetchWalletBalance(token));
      } catch (error) {
        console.error("Error fetching plan details:", error);
      }
    },
    async fetchWalletBalance(token) {
      try {
        const { data } = await withdrawService.getWallet(token);
        const response = data.data;
        this.exponent = response.withdrawScale;

        this.availableAmount = this.$thousandMask(
          response.strBalance,
          response.withdrawScale
        );
      } catch (error) {
        console.error("Error fetching wallet:", error);
      }
    },
    async stakePlanSubmit() {
      this.isLoading = true;
      const payload = {
        planDetailId: this.planId,
        stakedAmount: this.orderAmount,
        isAutoRenewal: 0
      };

      try {
        const { data } = await StakingService.stakePlan(payload);
        if (data.code === 0) {
          this.showStatus = true;
          this.StatusData = data.data;
        }
      } catch (error) {
        console.error("Staking error:", error);
      } finally {
        this.isLoading = false;
      }
    },
    async getDisclaimer() {
      try {
        const response = await StakingService.getDisclaimer(this.planId);
        this.disclaimer = response.data.data.disclaimer;
      } catch (error) {
        console.log(error);
      }
    }
  },
  computed: {
    cryptoExchange() {
      if (!this.minWithdraw || !this.maxWithdraw) return "";

      const order = parseFloat(this.orderAmount);
      const available = this.$removeThousand(this.availableAmount);
      const min = parseFloat(this.minWithdraw);
      const max = parseFloat(this.maxWithdraw);

      // if (!order) return "";

      if (order > available) {
        return this.$t("operationsPage.transfer.balanceNotEnought");
      }
      if (order > max) {
        return this.$t("staking.stakingDetailPage.maxTransfer", {
          amount: `${this.$thousandMask(this.maxWithdraw)} ${
            this.selectedCurrency
          }`
        });
      }
      if (order < min) {
        return this.$t("staking.stakingDetailPage.minTransfer", {
          amount: `${this.$thousandMask(this.minWithdraw)} ${
            this.selectedCurrency
          }`
        });
      }

      return "";
    },
    planDetailHeader() {
      return [
        {
          label: this.$t("staking.stakingPlans.plans.details.minMaxLimit"),
          show: true,
          dir: "ltr",
          value: `${this.$thousandMask(
            this.planData.planDetail.maxStakePerUser,
            this.planData.coinDto.stakeScale
          )} ${this.planData.coinDto.coinUnit} / ${this.$thousandMask(
            this.planData.planDetail.minStakePerUser,
            this.planData.coinDto.stakeScale
          )} ${this.planData.coinDto.coinUnit} `
        },
        {
          label: this.$t("staking.stakingDetailPage.maxPlanCapacity"),
          show: true,
          dir: "ltr",
          value: `${this.$thousandMask(
            this.planData.planDetail.maxCapacity,
            this.planData.coinDto.stakeScale
          )} ${this.planData.coinDto.coinUnit}`
        },
        {
          label: this.$t("staking.stakingDetailPage.entryFee"),
          show: true,
          dir: "ltr",
          value:
            this.planData.planDetail.enterFee === 0
              ? this.$t("common.free")
              : `${this.planData.planDetail.enterFee} %`
        },
        {
          label: this.$t("staking.stakingDetailPage.cancelFee"),
          show: this.planData.planDetail.cancelable,
          dir: "ltr",
          value:
            this.planData.planDetail.cancelFee === 0
              ? this.$t("common.free")
              : `${this.planData.planDetail.cancelFee} %`
        },
        {
          label: this.$t("staking.stakingDetailPage.canCancel"),
          show: !this.planData.planDetail.cancelable,
          dir: "ltr",
          value: this.planData.planDetail.cancelable
            ? this.$t("staking.stakingPlans.plans.details.existed")
            : this.$t("staking.stakingPlans.plans.details.notExisted")
        },
        {
          label: this.$t(
            "staking.stakingPlans.dialogDetail.planInfo.Waiting_Period_For_Asset_Release"
          ),
          show: true,
          dir: this.$vuetify.rtl ? "rtl" : "ltr",
          value: this.$t(
            "staking.stakingDetailPage.oneDayAfterPlanCompletion",
            { day: this.planData.planDetail.releaseDuration }
          )
        },
        {
          label: this.$t(
            "staking.stakingPlans.dialogDetail.planInfo.Waiting_Period_For_Asset_Release_After_Withdrawal"
          ),
          show: this.planData.planDetail.cancelable,
          dir: this.$vuetify.rtl ? "rtl" : "ltr",
          value: this.$t("staking.stakingDetailPage.oneDayAfterWithdrawal", {
            day: this.planData.planDetail.cancelReleaseDuration
          })
        }
      ];
    },
    rewardItems() {
      return [
        {
          label: this.$t("staking.stakingDetailPage.Daily"),
          value: this.dailyReward
        },
        {
          label: this.$t("staking.stakingDetailPage.Weekly"),
          value: this.weeklyReward
        },
        {
          label: this.$t("staking.stakingDetailPage.Monthly"),
          value: this.monthlyReward
        },
        {
          label: this.$t("staking.stakingDetailPage.Yearly"),
          value: this.yearlyReward
        }
      ];
    },
    netAmount() {
      const amount = parseFloat(this.orderAmount) || 0;
      const fee = parseFloat(this.planData.planDetail.enterFee) || 0;
      return amount * (1 - fee / 100);
    },
    yearlyReward() {
      const apy = parseFloat(this.activeAPY) || 0;
      return (this.netAmount * apy) / 100;
    },
    monthlyReward() {
      return this.yearlyReward / 12;
    },
    weeklyReward() {
      return (this.yearlyReward / 365) * 7;
    },
    dailyReward() {
      return this.yearlyReward / 365;
    }
  },
  watch: {
    orderAmount() {
      this.showValidation = true;
      this.transferFlag = this.cryptoExchange !== "";
    }
  }
};
</script>

<style scoped>
.custom-checkbox {
  .v-input--selection-controls {
    margin-top: 0;
    padding-top: 0;
  }
  .v-input__slot {
    align-items: start !important;
    .v-input--selection-controls__input {
      margin-top: 18px !important;
    }
  }
  .v-expansion-panel--active > .v-expansion-panel-header {
    min-height: 0 !important;
  }
}
.px-custom {
  padding-inline: 8px;
}
</style>
